import mixins from '@synergycms_core/less/mixins.js';

export default {
  page: {},
  section: {},
  sectionForm: {},
  customerForm: {},
  inputBox: {},
  labelText: {},
  labelTextTitle: {},
  inputText: {},
  textAreaBox: {},
  checkBox: {},
  inputCheck: {},
  phoneContainer: {},
  oblig: {},
  inputRadio: {},
  vertical: {},
  docTypeContainer: {},
  row: {},
  test: {},
  isSelected: {},
  isFocused: {},
  countries: {},
  flexGrowSmall: {},
  flexGrowLarge: {},
  containerAreaComment: {},
  robotoBtn: {
    fontFamily: 'Roboto'
  },
  promotionCod: {
    padding: '15px 0 0',
    boxSizing: 'border-box',
    '& $promoContainer': {
      position: 'relative',
      textAlign: 'right',
      border: '1px solid #ddd',
      ...mixins.boxShadow('0 0 2px -1px fade(#000, 50%)'),
      '& $promoCodeIcon': {
        fill: (data) => data.mainColor,
        width: '24px',
        cursor: 'pointer',
        height: '20px',
        marginTop: '-10px',
        position: 'absolute',
        left: '11px',
        top: '50%',
        '&:lang(ar)': {
          left: 'auto',
          right: '11px'
        }
      },
      '& $promoCodeBox': {
        cursor: 'pointer',
        textAlign: 'left',
        display: 'table',
        paddingLeft: '44px',
        height: '40px',
        width: '100%',
        ...mixins.boxSizing(),
        '& $inputPromo': {
          font: (data) => '300 13px ' + data.fontFamily1,
          ...mixins.boxSizing(),
          display: 'table-cell',
          verticalAlign: 'middle',
          color: '#000',
          background: 'transparent',
          textTransform: 'uppercase',
          outline: '0',
          height: '40px',
          width: '100%',
          border: 'none',
          paddingRight: '10px',
          '&:focus': {
            '& ~ $insertCode': {
              display: 'none'
            },
            '& ~ $submitButtonContainer': {
              '& $promoCodeButton': {
                display: 'block'
              }
            }
          },
          '&:not([value=""])': {
            '& ~ $insertCode': {
              display: 'none'
            },
            '& ~ $submitButtonContainer': {
              '& $promoCodeButton': {
                display: 'block'
              }
            }
          },
          '@media (min-width: 801px)': {
            fontSize: '16px',
            height: '50px'
          },
          '&:lang(ar)': {
            paddingRight: '0',
            paddingLeft: '10px'
          }
        },
        '& $insertCode': {
          font: (data) => '300 13px ' + data.fontFamily1,
          ...mixins.transitionAll(),
          position: 'absolute',
          top: '12px',
          left: '44px',
          right: '30px',
          color: '#000',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          '@media (min-width: 801px)': {
            top: '17px'
          },
          '&:lang(ar)': {
            left: '30px',
            right: '44px'
          }
        },
        '& $submitButtonContainer': {
          ...mixins.boxSizing(),
          display: 'table-cell',
          verticalAlign: 'middle',
          width: 'auto',
          '@media (min-width: 801px)': {
            paddingRight: '5px'
          },
          '&:lang(ar)': {
            '@media (min-width: 801px), print': {
              paddingLeft: '5px',
              paddingRight: '0'
            }
          }
        },
        '@media (min-width: 801px)': {
          height: '50px'
        },
        '&:lang(ar)': {
          textAlign: 'right',
          paddingRight: '44px',
          paddingLeft: 0
        }
      },
      '& $promoCodeButton': {
        display: 'none',
        verticalAlign: 'top',
        height: '40px',
        width: '90px',
        cursor: 'pointer',
        position: 'relative',
        zIndex: '3',
        textTransform: 'uppercase',
        fontSize: '13px',
        float: 'right',
        padding: '3px',
        overflow: 'hidden',
        font: "16px 'Roboto', sans-serif",
        '@media (min-width: 901px)': {
          height: '40px'
        },
        '@media (min-width: 801px)': {
          width: '120px'
        },
        '&:lang(ar)': {
          float: 'left'
        }
      },
      '& $inputBox': {
        marginBottom: 0
      },
      '& $rightCode': {
        position: 'absolute',
        left: '0',
        bottom: '-18px',
        '&:lang(ar)': {
          left: 'auto',
          right: '0'
        }
      },
      '&:lang(ar)': {
        textAlign: 'left'
      }
    },
    '&:first-of-type': {
      paddingTop: '0',
      '@media (min-width: 801px)': {
        marginRight: '35px',
        '&:lang(ar)': {
          marginRight: '0',
          marginLeft: '35px'
        }
      }
    },
    '@media (min-width: 801px)': {
      display: 'inline-block',
      verticalAlign: 'middle',
      width: 'calc(100% / 2 - 19px)',
      padding: 0,
      overflow: 'inherit'
    }
  },
  rateTooltip: {
    textAlign: 'center',
    position: 'absolute',
    maxWidth: '250px',
    display: 'table',
    backgroundColor: '#fc0',
    font: "11px 'Roboto',sans-serif",
    color: '#333',
    padding: '20px 9px',
    zIndex: '700',
    '@media (max-width:600px)': {
      paddingTop: '25px'
    }
  },
  tooltipArrinvingHour: {},
  tooltipEmail: {},
  tooltipPointerStyle: {
    backgroundColor: '#fc0',
    width: '10px',
    height: '10px',
    '&$tooltipArrinvingHour': {
      marginLeft: '10px',
      marginTop: '5px',
      zIndex: 'unset',
      '& + div$rateTooltip': {
        marginTop: '5px'
      }
    },
    '&$tooltipEmail': {
      zIndex: 'unset',
      marginLeft: '4px'
    }
  },
  ratePopover: {
    height: '10%',
    width: '10%'
  },
  promoContainer: {},
  promoCodeIcon: {},
  rightMargin: {},
  rightMarginNo: {},
  promoCodeBox: {},
  inputPromo: {},
  insertCode: {},
  submitButtonContainer: {},
  promoCodeButton: {},
  correctCodeButton: {},
  rightCode: {},
  checksPayment: {},
  roomPreferencesForm: {},
  roomHeader: {},
  roomTitle: {},
  bedIcon: {},
  roomSubTitle: {},
  roomToggle: {
    position: 'absolute',
    top: '0',
    right: '0',
    left: '0',
    bottom: '0',
    height: '49px',
    width: '100%',
    '&$up': {
      '& $searchOptionsButtonIconOpen': {
        font: (data) => '13px/1px ' + data.fontFamily1,
        color: (data) => data.mainColor,
        right: '30px',
        top: '50%',
        position: 'absolute',
        display: 'block',
        transition: 'all .2s ease',
        rotate: '180deg',
        '&:lang(ar)': {
          right: 'auto',
          left: '30px'
        },
        '@media (max-width: 900px)': {
          right: '23px'
        }
      }
    },
    '&$down': {
      '& $searchOptionsButtonIconOpen': {
        font: (data) => '13px/1px ' + data.fontFamily1,
        color: (data) => data.mainColor,
        content: "'e052'",
        right: '30px',
        top: '50%',
        position: 'absolute',
        display: 'block',
        transition: 'all .2s ease',
        '&:lang(ar)': {
          left: '30px',
          right: 'auto'
        },
        '@media (max-width: 900px)': {
          right: '23px'
        }
      }
    },
    '&:lang(ar)': {
      left: '10px',
      right: 'auto'
    }
  },
  promotionalCodeContainer: {
    paddingBottom: '20px'
  },
  promotionalCodeOverflow: {
    paddingTop: '25px'
  },
  relativeFoldCommentaryContainer: {
    padding: '20px 0'
  },
  up: {},
  searchOptionsButtonIcon: {},
  searchOptionsButtonIconOpen: {},
  down: {},
  preferences: {},
  preference: {},
  message: {},
  roomDetail: {},
  travelClubContainer: {},
  cardHolderContainer: {},
  travelClubCards: {},
  commentSection: {},
  travelCards: {},
  travelClubAltLogoCont: {},
  travelClubAltLogo: {},
  promotionCodContainer: {},
  paymentMethod: {},
  wrapperPciFrame: {
    overflow: 'hidden',
    width: '100%'
  },
  errorPCI: {},
  acceptBoxes: {},
  finalPrice: {},
  tableContainer: {},
  tableCell: {},
  buttonContainer: {},
  tableContainer2: {},
  taxesContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  hotelFiscalInfoContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  cardImagesBox: {
    display: 'flex',
    flexDirection: 'row',
    gap: '10px'
  },
  cardImagesBoxTPV: {
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
    marginBottom: '15px'
  },
  cardLogo: {},
  promotionCodeError: {
    padding: '7px',
    borderColor: '#d0021b',
    color: '#d0021b',
    display: 'block',
    fontSize: '12px',
    left: '0',
    bottom: '-27px',
    position: 'absolute',
    '& span': {
      verticalAlign: 'bottom',
      paddingRight: '5px'
    }
  },
  promoCodeDiscount: {
    marginTop: '10px',
    color: (data) => data.secondColor,
    paddingLeft: '5px',
    '&:lang(ar)': {
      paddingLeft: 0,
      paddingRight: '5px'
    }
  },
  '@keyframes rotateInfiniteCircle': {
    from: { transform: 'rotate(0deg)' },
    to: { transform: 'rotate(359deg)' }
  },
  loadingPromoCodeSvg: {
    fill: (data) => data.mainColor,
    height: '30px',
    backgroundSize: 'contain',
    background: 'no-repeat center',
    animation: '$rotateInfiniteCircle 2s infinite linear',
    display: 'inline-block',
    verticalAlign: 'middle',
    '& .cls-1': { opacity: 0.2 },
    '& .cls-2': { opacity: 0.8 },
    '& .cls-3': { opacity: 0.1 },
    '& .cls-4': { opacity: 0.7 },
    '& .cls-5': { opacity: 0.05 },
    '& .cls-6': { opacity: 0.6 },
    '& .cls-7': { opacity: 0.03 },
    '& .cls-8': { opacity: 0.5 },
    '& .cls-10': { opacity: 0.4 },
    '& .cls-11': { opacity: 0.9 },
    '& .cls-12': { opacity: 0.3 }
  },
  title: {},
  noPadding: {},
  relativeFoldContainer: {
    paddingRight: '20px',
    '& $roomToggle': {
      right: '0',
      cursor: 'pointer'
    },
    '@media (min-width: 901px)': {
      paddingRight: '35px',
      '&:lang(ar)': {
        paddingRight: '0'
      }
    }
  },
  noMargin: {},
  pciFrame: {
    fontSize: '20px',
    overflow: 'hidden',
    height: '100%',
    width: '100%'
  },
  pciFrameCVV: {
    fontSize: '20px',
    overflow: 'hidden',
    height: '100%',
    width: '310px'
  },
  summaryContainer: {},
  alertContainer: {},
  alertContent: {},
  alertTitle: {},
  alertButtonContainer: {},
  alertButton: {},
  show: {
    display: 'block'
  },
  hide: {
    display: 'none'
  },
  promotionalCode: {
    font: (data) => '500 20px ' + data.fontFamily1,
    marginBottom: '15px',
    display: 'block'
  },
  policiesTextToggle: {
    display: 'inline',
    cursor: 'pointer',
    textAlign: 'left',
    padding: '0 20px',
    '@media (min-width: 801px)': {
      padding: '0'
    }
  },
  travelReason: {
    clear: 'both'
  },
  travelReasonMargin: {
    '@media (min-width: 901px)': {
      display: 'inline-block',
      marginTop: '-10px',
      width: 'calc(50% - 15px)'
    }
  },
  travelReasonContainer: {
    display: 'block',
    marginTop: '10px'
  },
  guestFormCheckbox: {
    clear: 'both',
    marginRight: '30px',
    '@media (min-width: 901px)': {
      display: 'inline-block',
      marginTop: '-10px',
      width: 'calc(50% - 15px)'
    }
  },
  guestForm: {
    clear: 'both',
    overflow: 'hidden',
    position: 'relative'
  },
  guestFormTitle: {},
  invoiceForm: {
    clear: 'both',
    position: 'relative'
  },
  // Fila del toggle de factura: texto a la izquierda, toggle deslizante a la derecha.
  invoiceToggleRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '15px'
  },
  invoiceToggleLabel: {
    flex: '1 1 auto',
    textAlign: 'left'
  },
  invoiceRow: {
    '&:first-of-type': {
      marginTop: '15px'
    },
    '@media (min-width: 901px)': {
      display: 'flex',
      gap: '30px',
      '& $inputBox': {
        flex: '1 1 0',
        width: 'auto !important',
        float: 'none !important',
        marginRight: '0 !important'
      }
    }
  },
  invoiceGridRow: {
    '&:first-of-type': {
      marginTop: '15px'
    },
    '@media (min-width: 901px)': {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: '30px',
      '& $inputBox': {
        width: '100% !important',
        float: 'none !important',
        marginRight: '0 !important',
        minWidth: 0
      },
      '& $flexGrowLarge': {
        gridColumn: 'span 2'
      }
    }
  },
  invoiceRowInlineMobile: {
    '@media (max-width: 900px)': {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: '10px',
      '& $inputBox': {
        width: '100% !important',
        float: 'none !important',
        marginRight: '0 !important',
        minWidth: 0
      },
      '& $flexGrowLarge': {
        gridColumn: 'span 2'
      }
    }
  },
  termsST: {},
  politicsText: {
    fontSize: '13px',
    color: (data) => data.mainColor
  },
  footerText: {
    fontFamily: 'Roboto, sans-serif',
    fontWeight: 400,
    fontStyle: 'Regular',
    font: "15px / 16.41px 'Open Sans', sans-serif",
    color: '#767676',
    '@media (min-width: 801px)': {
      fontSize: '13px'
    },
    '@media (min-width: 1080px)': {
      fontSize: '14px'
    }
  },
  hotelModalStyle: {
    ...mixins.transitionAll('0.5s'),
    backgroundColor: 'rgba(0,0,0,0.5)',
    position: 'fixed',
    top: '0',
    right: '0',
    bottom: '0',
    left: '0',
    zIndex: '600',
    padding: '0',
    '& $availModalcontent': {
      position: 'absolute',
      top: '0',
      right: '0',
      left: '0',
      bottom: '0',
      overflow: 'auto',
      background: '#fff',
      '& $closeButton': {
        color: (data) => data.mainColor,
        position: 'fixed',
        right: '15px',
        top: '15px',
        border: '0',
        fontSize: '15px',
        background: 'none',
        zIndex: '1',
        '&:lang(ar)': {
          right: 'auto',
          left: '15px'
        }
      },
      '& $headerModal': {
        padding: '15px 40px 14px 20px',
        border: '1px solid #d8d8d8',
        textAlign: 'left',
        position: 'sticky',
        top: '0',
        background: '#fff',
        borderRight: 'none',
        '& $modalTitle': {
          font: (data) => '18px ' + data.fontFamily2,
          '@media (min-width: 801px)': {
            fontSize: '24px'
          }
        },
        '@media (min-width: 801px)': {
          padding: '25px 54px 25px 30px'
        },
        '&:lang(ar)': {
          textAlign: 'right',
          paddingLeft: '40px',
          paddingRight: '20px',
          '@media (min-width: 801px)': {
            paddingRight: '30px',
            paddingLeft: '54px'
          }
        }
      },
      '& $modalTabsList': {
        height: 'inherit',
        '& $titleListBlock': {
          padding: '19px 20px 22px',
          textAlign: 'left',
          '@media (min-width: 801px)': {
            padding: '25px 30px'
          },
          '&:lang(ar)': {
            textAlign: 'right'
          },
          '& $termsST': {
            '& p': {
              margin: '15px 0'
            },
            '& ul': {
              marginBlockStart: '1em',
              marginBlockEnd: '1em',
              paddingInlineStart: '40px',
              '& li': {
                listStyle: 'disc'
              }
            }
          }
        }
      },
      '@media (min-width: 801px)': {
        ...mixins.transitionAll('0.5s'),
        right: '0',
        width: '600px',
        left: 'auto'
      },
      '&:lang(ar)': {
        '@media (min-width: 801px), print': {
          left: 0,
          right: 'auto'
        }
      }
    }
  },
  availModalcontent: {},
  closeButton: {},
  headerModal: {},
  modalTitle: {},
  modalTabsList: {},
  titleListBlock: {},
  legalTextContainer: {},
  arrivingHours: {},
  userTravelContainer: {},
  promotionalCodeTitle: {},
  infoFloatIcon: {
    '& svg': {
      fontSize: '13px',
      width: '15px',
      height: '19px',
      padding: '1px',
      marginLeft: '7px',
      display: 'inline-flex',
      verticalAlign: 'bottom',
      position: 'relative',
      boxSizing: 'border-box',
      bottom: '3px',
      fill: data => data.mainColor,
      '@media (min-width: 901px)': {
        fontSize: '14px'
      }
    }
  },
  defaultStyle: {
    minHeight: 'calc(100vh - 29px)',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    '@media(min-width:901px)': {
      minHeight: 'calc(100vh - 62px)'
    },
    margin: '0 auto',
    '&:lang(ar)': {
      direction: 'rtl'
    },
    '& $page': {
      maxWidth: '1190px',
      minHeight: '100vh',
      overflow: 'hidden',
      padding: '20px 0 40px',
      boxSizing: 'border-box',
      '@media (min-width: 901px)': {
        margin: '0 auto'
      },
      '@media (max-width: 375px)': {
        width: '-webkit-fill-available'
      },
      '& $section': {
        font: (data) => '300 11px ' + data.fontFamily1,
        width: '100%',
        textAlign: 'left',
        '&:lang(ar)': {
          textAlign: 'right',
          '@media (min-width: 901px), print': {
            float: 'right'
          }
        },
        '& $sectionForm': {
          background: '#fff'
        },
        '& $customerForm': {
          '& > div': {
            padding: '15px',
            borderBottom: '1px solid #d8d8d8',
            boxSizing: 'border-box',
            '@media (min-width: 901px)': {
              padding: '15px 30px'
            }
          },
          '& $guestForm': {
            '@media (min-width: 901px)': {
              padding: '11px 30px 30px'
            }
          },
          '& $userTravelContainer': {
            '@media (min-width: 901px)': {
              padding: '15px 30px 30px'
            }
          },
          '& $inputBox': {
            position: 'relative',
            cursor: 'pointer',
            display: 'block',
            marginBottom: '15px',
            paddingLeft: '0',
            '&$memberPass': {
              marginBottom: '20px'
            },
            '& $containerAreaComment': {
              '& > textarea': {
                padding: '25px 40px 0px 15px',
                whiteSpace: 'pre-wrap',
                textAlign: 'justify',
                overflow: 'auto'
              },
              '& > span': {
                padding: '5px 0px',
                backgroundColor: '#fff',
                left: '15px',
                top: '0px !important',
                width: '93%',
                borderTop: '1px solid #d8d8d8'
              }
            },
            '&:before': {
              content: 'none'
            },
            '& $arrivingHours': {
              boxSizing: 'content-box',
              position: 'absolute',
              display: 'flex',
              '& $labelText': {
                top: '6px',
                zIndex: '1',
                left: '16px',
                display: 'inline-flex',
                position: 'relative',
                width: 'fit-content',
                pointerEvents: 'none',
                '@media (min-width: 901px)': {
                  left: '15px'
                }
              },
              '& $infoFloatIcon': {
                '& svg': {
                  marginLeft: '20px',
                  zIndex: '1',
                  top: '5px',
                  '@media (min-width: 901px)': {
                    fontSize: '14px'
                  }
                }
              }
            },
            '&:nth-child(odd)': {
              '&$arrivingHours': {
                cursor: 'pointer',
                marginBottom: '35px'
              },
              '@media (min-width: 901px)': {
                marginRight: '30px',
                '&:lang(ar)': {
                  marginLeft: '30px',
                  marginRight: '0'
                }
              }
            },
            '& $labelText': {
              position: 'absolute',
              top: '14px',
              left: '15px',
              zIndex: '0',
              color: '#767676',
              right: '10px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              ...mixins.transition('top 0.3s'),
              '&$labelHours':{
                display: 'flex',
                top: '6px',
                zIndex: '2',
              },
              '&$infoFloatIcon': {
                '& svg': {
                  fill: (data) => data.mainColor
                }
              },
              '@media (min-width: 901px)': {
                top: '18px',
                fontSize: '13px',
                width: 'fit-content'
              },
              '&:lang(ar)': {
                left: 'auto',
                right: '15px',
                '@media (min-width: 901px), print': {
                  float: 'right'
                }
              },
              '&$citiesLabel': {
                top: '4px',
                zIndex: '1'
              }
            },
            '& $inputText': {
              font: (data) => '300 13px ' + data.fontFamily1,
              paddingRight: '40px',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              boxShadow: 'none',
              '&:lang(ar)': {
                direction: 'rtl'
              },
              '&:not([value=""]) ~ $labelText': {
                top: '6px'
              },
              '@media (min-width: 901px)': {
                height: '50px',
                fontSize: '16px',
                boxShadow: '0 0 2px -1px rgb(0,0,0,0.5)'
              },
              '&.travelclub_card': {
                '@media (min-width: 901px)': {
                  fontSize: '15px'
                }
              }
            },
            '@media (min-width: 901px)': {
              width: 'calc(50% - 15px)',
              float: 'left',
              '&:lang(ar)': {
                float: 'right'
              }
            },
            '&$textAreaBox': {
              width: '100%',
              margin: '20px 0 5px',
              '& $labelText': {
                top: '13px'
              }
            }
          },
          '& $hide': {
            display: 'none'
          },
          '& $rightMargin': {
            '@media (min-width: 901px)': {
              marginRight: '30px'
            }
          },
          '& $rightMarginNo': {
            '@media (min-width: 901px)': {
              marginRight: '0 !important'
            }
          },
          '& $inputText:focus': {
            '& ~ $labelText': {
              top: '6px'
            }
          },
          '& $checkBox': {
            display: 'block',
            position: 'relative',
            paddingLeft: '29px',
            '&:before': {
              content: 'none'
            },
            '&:not(:last-of-type)': {
              marginBottom: '15px',
              '&$membersCheckBox': {
                marginBottom: '20px'
              }
            },
            '& > span': {
              fontSize: '13px'
            },
            '& $inputCheck': {
              position: 'absolute',
              top: '0',
              left: '0',
              '&:lang(ar)': {
                left: 'auto',
                right: 0
              },
              '&:after': {
                ...mixins.boxShadow('unset')
              },
              '&:focus-visible': {
                outline: 'none'
              }
            },
            '&$oblig': {
              paddingRight: '30px',
              '&:lang(ar)': {
                paddingLeft: '30px'
              }
            },
            '&:lang(ar)': {
              paddingRight: '29px',
              paddingLeft: 0
            }
          },
          '& $phoneContainer': {
            position: 'relative',
            zIndex: 10,
            marginBottom: '-12px',
            '&:nth-child(odd)': {
              '&:lang(ar)': {
                '@media (min-width: 901px), print': {
                  marginLeft: '30px',
                  marginRight: 0
                },
                '& $inputText': {
                  direction: 'ltr',
                  textAlign: 'right'
                }
              }
            },
            '& $inputBox': {
              display: 'inline-block',
              width: 'calc(100% - 97px)',
              verticalAlign: 'top',
              float: 'none',
              marginBottom: '9px'
            }
          },
          '& $nameContainer': {
            position: 'relative',
            zIndex: 10,
            '&:nth-child(odd)': {
              '&:lang(ar)': {
                '@media (min-width: 901px), print': {
                  marginLeft: '30px',
                  marginRight: 0
                },
                '& $inputText': {
                  direction: 'ltr',
                  textAlign: 'right'
                }
              }
            },
            '& $inputBox': {
              display: 'inline-block',
              verticalAlign: 'top',
              float: 'none',
              marginBottom: '0',
              '&$withTreatment': {
                width: 'calc(100% - 121px)'
              }
            }
          },
          '& $docTypeContainer': {
            marginBottom: '-12px',
            '& $inputBox': {
              display: 'inline-block',
              width: 'calc(100% - 97px)',
              verticalAlign: 'top',
              float: 'none',
              marginBottom: '9px'
            }
          },
          '& $cardHolderContainer': {
            borderBottom: 'none',
            padding: '0 0 0 15px',
            '& $inputBox': {
              display: 'inline-block',
              width: 'calc(100% - 15px)',
              verticalAlign: 'top',
              float: 'none',
              marginBottom: '0'
            },
            '& $labelTextTitle': {
              position: 'absolute',
              top: '0',
              left: '15px',
              zIndex: '0',
              right: '10px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              ...mixins.transition('top 0.3s'),
              marginTop: '16px',
              fontSize: '16px',
              fontWeight: '400',
              color: '#6e6f7b',
              '&:lang(ar)': {
                left: 'auto',
                right: '15px',
                '@media (min-width: 901px), print': {
                  float: 'right'
                }
              }
            },
            '& $promotionalCodeTitle': {
              marginBottom: '4px',
              fontSize: '15px',
              fontFamily:
                '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
              color: '#30313d',
              fontWeight: '400'
            },
            '@media (min-width: 901px)': {
              padding: '0 0 0 30px',
              width: 'calc(100% - 15px)'
            },
            '& input': {
              padding: '16px',
              backgroundColor: '#f1f1f1',
              borderRadius: '12px',
              transition: 'background 0.15s ease, border 0.15s ease, box-shadow 0.15s ease, color 0.15s ease',
              boxShadow: 'none',
              border: 'none',
              height: '50px'
            },
            '& $inputText': {
              '&:not([value=""]) ~ $labelTextTitle': {
                display: 'none'
              }
            }
          },
          '& $inputRadio': {
            paddingTop: '10px',
            '& span:before': {
              ...mixins.boxShadow('unset')
            }
          },
          '& $checksPayment': {
            paddingTop: '20px',
            background: '#fff',
            borderTop: '1px solid #d8d8d8',
            '& $checkBox': {
              position: 'relative',
              display: 'block',
              paddingLeft: '29px',
              '& $inputCheck': {
                content: "''",
                position: 'absolute',
                left: '0',
                top: '0',
                width: '16px',
                height: '16px',
                border: '1px solid #ddd',
                '&:lang(ar)': {
                  left: 'auto',
                  right: 0
                }
              },
              '& span': {
                font: (data) => '300 13px/1.38 ' + data.fontFamily1
              },
              '&:last-of-type': {
                '@media (min-width: 901px)': {
                  marginBottom: '0'
                }
              },
              '&:lang(ar)': {
                paddingLeft: 0,
                paddingRight: '29px'
              }
            },
            '@media (min-width: 901px)': {
              padding: '20px 30px'
            }
          },
          '& $roomPreferences': {
            pointer: 'cursor',
            font: (data) => '500 16px ' + data.fontFamily1,
            backgroundColor: '#fff',
            color: '#000',
            textAlign: 'left',
            padding: '11px 0 0',
            width: '100%',
            borderBottom: 'none',
            boxSizing: 'border-box',
            '& $roomPreferencesForm': {
              backgroundColor: '#ebebeb'
            },
            '& $roomDetail': {
              pointer: 'cursor',
              borderBottom: '1px solid #999',
              background: '#ebebeb',
              '&:last-child': {
                borderBottom: 'none'
              },
              '& $roomHeader': {
                width: '100%',
                textAlign: 'left',
                padding: '10px 19px 10px 10px',
                fontSize: '13px',
                fontWeight: 'normal',
                position: 'relative',
                boxSizing: 'border-box',
                '& $roomTitle': {
                  position: 'relative',
                  '& > span': {
                    display: 'block',
                    paddingLeft: '32px',
                    fontWeight: '500',
                    position: 'relative',
                    fontSize: '16px',
                    '&:lang(ar)': {
                      paddingRight: '32px',
                      paddingLeft: 0,
                      '@media (min-width: 901px)': {
                        paddingRight: '43px'
                      }
                    }
                  },
                  '& $bedIcon': {
                    color: (data) => data.mainColor,
                    fontSize: '24px',
                    left: '0',
                    top: '50%',
                    position: 'absolute',
                    paddingLeft: '0',
                    marginTop: '-17px',
                    '@media (min-width: 801px)': {
                      fontSize: '32px',
                      marginTop: '-22px'
                    },
                    '&:lang(ar)': {
                      left: 'auto',
                      right: 0,
                      paddingRight: 0
                    }
                  },
                  '& span': {
                    '@media (min-width: 801px)': {
                      fontSize: '24px',
                      paddingLeft: '43px',
                      fontWeight: '300'
                    },
                    '&:lang(ar)': {
                      '@media (min-width: 801px), print': {
                        paddingLeft: 0,
                        paddingRight: '43px'
                      }
                    }
                  },
                  '&:after': {
                    fontSize: '32px'
                  }
                },
                '& $roomSubTitle': {
                  margin: '4px 0',
                  paddingRight: '15px',
                  '& span': {
                    '@media (min-width: 801px)': {
                      fontWeight: 'bold',
                      fontSize: '18px'
                    }
                  },
                  '&:lang(ar)': {
                    paddingLeft: '15px',
                    paddingRight: 0
                  }
                },
                '& $roomToggle': {
                  cursor: 'pointer',
                  position: 'absolute',
                  display: 'block',
                  top: '0',
                  right: '0',
                  height: '100%',
                  width: '100%',
                  left: 'auto',
                  bottom: 'auto',
                  '&$up': {
                    '& $searchOptionsButtonIconOpen': {
                      font: (data) => '13px/1px ' + data.fontFamily1,
                      color: (data) => data.mainColor,
                      right: '22px',
                      top: '50%',
                      position: 'absolute',
                      display: 'block',
                      transition: 'all .2s ease',
                      rotate: '180deg',
                      '&:lang(ar)': {
                        right: 'auto',
                        left: '30px'
                      },
                      '@media (min-width: 801px)': {
                        right: '54px'
                      }
                    }
                  },
                  '&$down': {
                    '& $searchOptionsButtonIconOpen': {
                      font: (data) => '13px/1px ' + data.fontFamily1,
                      color: (data) => data.mainColor,
                      content: "'e052'",
                      right: '22px',
                      top: '50%',
                      position: 'absolute',
                      display: 'block',
                      transition: 'all .2s ease',
                      '&:lang(ar)': {
                        left: '30px',
                        right: 'auto'
                      },
                      '@media (min-width: 801px)': {
                        right: '54px'
                      }
                    }
                  },
                  '&:lang(ar)': {
                    left: '10px',
                    right: 'auto'
                  }
                },
                '@media (min-width: 801px)': {
                  padding: '20px 30px'
                },
                '&:lang(ar)': {
                  textAlign: 'right',
                  paddingLeft: '19px',
                  paddingRight: '10px',
                  '@media (min-width: 801px), print': {
                    paddingLeft: '25px',
                    paddingRight: '0'
                  }
                }
              },
              '& $preferences': {
                cursor: 'pointer',
                padding: '0 10px 10px 10px',
                '& $preference': {
                  ...mixins.boxShadow('0 0 2px -1px rgba(0,0,0,0.5)'),
                  ...mixins.boxSizing(),
                  marginBottom: '10px',
                  border: '1px solid #ddd',
                  width: '100%',
                  '&:nth-of-type(odd)': {
                    '@media (min-width: 801px)': {
                      marginRight: '25px'
                    },
                    '&:lang(ar)': {
                      '@media (min-width: 801px), print': {
                        marginLeft: '25px',
                        marginRight: 0
                      }
                    }
                  },
                  '@media (min-width: 801px)': {
                    width: 'calc(50% - 15px)',
                    display: 'inline-block',
                    verticalAlign: 'top'
                  }
                },
                '& > :nth-last-child(2)': {
                  marginBottom: '0'
                },
                '@media (min-width: 801px)': {
                  padding: ' 0 0 20px'
                }
              },
              '& $message': {
                display: 'block',
                marginTop: '16px',
                color: '#000',
                fontSize: '12px',
                lineHeight: '1.38',
                fontWeight: '300',
                '@media (min-width: 801px)': {
                  fontSize: '13px'
                }
              },
              '@media (min-width: 801px)': {
                padding: '0'
              }
            },
            '@media (min-width: 801px)': {
              padding: '0'
            },
            '&:lang(ar)': {
              textAlign: 'right'
            }
          },
          '& $travelClubContainer': {
            padding: '0'
          },
          '& $travelClubCards': {
            display: 'flex',
            justifyContent: 'space-between',
            gap: '15px'
          },
          '& $commentSection': {
            overflow: 'hidden',
            padding: '15px',
            position: 'relative',
            '& .travelclub_text': {
              maxWidth: '345px',
              paddingTop: '30px',
              display: 'block',
              marginBottom: '10px',
              fontWeight: '300',
              '& + label': {
                maxWidth: '340px'
              }
            },
            '@media (min-width: 801px)': {
              padding: '15px 30px',
              '& .travelclub_text': {
                '& + label': {
                  minWidth: '340px'
                }
              }
            }
          },
          '& $travelCards': {
            '& > div': {
              width: '120px',
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              '@media (min-width: 801px)': {
                width: '160px'
              }
            }
          },
          '& $travelClubAltLogoCont': {
            display: 'flex',
            flexDirection: 'column',
            width: '35%',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '5px',
            '& $travelClubAltLogo': {
              height: '40px',
              width: '40px'
            },
            '@media (min-width: 801px)': {
              flexDirection: 'row',
              justifyContent: 'flex-end',
              width: '25%'
            }
          },
          '& $promotionCodContainer': {
            padding: '15px',
            position: 'relative',
            '@media (min-width: 801px)': {
              borderBottom: '1px solid #d8d8d8',
              padding: '15px 30px'
            }
          },
          '& $paymentMethod': {
            font: (data) => '500 16px ' + data.fontFamily1,
            background: '#fff',
            padding: '15px 15px 10px',
            borderBottom: 'none',
            textAlign: 'left',
            position: 'relative',
            zIndex: 5,
            '@media (min-width: 901px)': {
              padding: '20px 30px 20px'
            },
            '&:lang(ar)': {
              textAlign: 'right'
            }
          },
          '& $errorPCI': {
            background: '#fae0e0'
          },
          '& $acceptBoxes': {
            clear: 'both',
            paddingTop: '25px',
            '& $checkBox': {
              '& $inputCheck': {
                '& input': {
                  visibility: 'unset',
                  position: 'absolute',
                  width: '1px',
                  height: '1px',
                  padding: '0px',
                  margin: '-1px',
                  overflow: 'hidden',
                  top: '0',
                  left: '0',
                  right: '0',
                  bottom: '0',
                  border: '0'
                },
                '@media (min-width: 901px)': {
                  top: '3px'
                }
              },
              '& > span': {
                '@media (min-width: 901px)': {
                  fontSize: '13px'
                }
              },
              '@media (min-width: 901px)': {
                lineHeight: '19px'
              }
            },
            '@media (min-width: 901px)': {
              padding: '20px 30px'
            }
          },
          '& $finalPrice': {
            font: (data) => '11px ' + data.fontFamily1,
            padding: '15px 20px',
            background: '#fff',
            borderBottom: 'none',
            '& $tableContainer': {
              display: 'table',
              width: '100%',
              captionSide: 'bottom',
              '& $tableCell': {
                display: 'table-cell',
                verticalAlign: 'bottom',
                outline: 'none',
                '&:first-of-type': {
                  '& > span:first-of-type': {
                    paddingBottom: '5px'
                  }
                },
                '&:nth-of-type(2)': {
                  textAlign: 'right',
                  '&:lang(ar)': {
                    textAlign: 'left'
                  }
                }
              },
              '& > span': {
                display: 'block',
                textAlign: 'right',
                fontSize: '14px',
                color: '#333'
              }
            },
            '& $buttonContainer': {
              paddingTop: '15px',
              display: 'table-caption',
              '& > button': {
                width: '100%',
                position: 'relative',
                padding: '0 25px 0 20px',
                '@media (min-width: 901px)': {
                  height: '50px'
                }
              },
              '@media (min-width: 901px)': {
                display: 'table-cell',
                padding: '0 0 0 30px',
                width: '215px',
                verticalAlign: 'middle'
              },
              '&:lang(ar)': {
                '@media (min-width: 801px), print': {
                  paddingLeft: '0',
                  paddingRight: '30px'
                }
              }
            },
            '@media (min-width: 901px)': {
              padding: '20px 30px 20px'
            }
          },
          '& $taxesContainer': {
            marginTop: '0',
            padding: '0 20px 15px',
            background: '#fff',
            borderBottom: 'unset',
            '@media (min-width: 901px)': {
              marginTop: '10px',
              paddingBottom: '15px',
              flexDirection: 'row',
              borderBottom: '1px solid #d8d8d8',
              '& > span': {
                fontSize: '13px'
              }
            }
          },
          '& $hotelFiscalInfo': {
            padding: '0 20px 15px',
            border: 'none'
          },
          '& $legalTextContainer': {
            ...mixins.boxShadow('0 2px 4px 0 rgba(0,0,0,0.07)'),
            marginTop: '15px',
            padding: '0 20px 15px',
            background: '#fff',
            '@media (min-width: 901px)': {
              marginTop: '10px'
            }
          },
          '& $guestFormTitle': {
            borderBottom: 'none',
            padding: '15px 15px 10px',
            '@media (min-width: 901px)': {
              padding: '20px 30px 0'
            }
          },
          '& $containerTaxesInForm': {
            padding: '15px 0 15px',
            borderBottom: 'unset'
          }
        },
        '@media (min-width: 901px)': {
          float: 'left',
          width: '64%',
          padding: 0
        }
      }
    },
    '& $title': {
      fontSize: '16px',
      fontWeight: '500',
      marginBottom: '10px',
      padding: '10px 15px 0',
      display: 'block',
      '&$noPadding': {
        margin: '0 0 10px',
        padding: '0',
        display: 'block',
        '@media (min-width: 901px)': {
          padding: 0,
          marginBottom: '15px'
        },
        '&$noMargin': {
          marginBottom: 0,
          fontWeight: 500,
          '@media (min-width: 901px)': {
            fontSize: '16px',
            '&:lang(ar)': {
              marginRight: '0'
            }
          }
        }
      },

      '&$promotionalCodeTitle': {
        fontSize: '14px',
        paddingLeft: '0',
        marginBottom: '10px',
        '@media (min-width: 901px)': {
          padding: 0,
          margin: '0 0 15px',
          fontSize: '14px'
        }
      },
      '@media (min-width: 901px)': {
        fontSize: '20px',
        fontWeight: '500',
        margin: '0 0 6px 10px',
        display: 'block'
      },
      '&:lang(ar)': {
        '@media (min-width: 901px), print': {
          marginLeft: 0,
          marginRight: '10px'
        }
      }
    },
    '& $summaryContainer': {
      ...mixins.boxSizing('content-box !important'),
      display: 'block',
      float: 'right',
      width: '31%',
      padding: '0 10px',
      '& > div': {
        position: 'fixed',
        left: '0px',
        top: '0',
        right: '0',
        bottom: '0',
        overflow: 'auto',
        background: '#fff',
        display: 'none',
        zIndex: '200',
        '@media (min-width: 901px), print': {
          position: 'static',
          display: 'block !important',
          border: '0.5px solid #d8d8d8'
        }
      },
      '@media (max-width: 900px)': {
        position: 'fixed',
        top: '0',
        right: '100%',
        zIndex: '200'
      },
      '&:lang(ar)': {
        float: 'left'
      },
      '& $vertical': {
        background: 'red'
      }
    },
    '& $alertContainer': {
      ...mixins.boxSizing(),
      padding: '15px 10px 0',
      '& $alertContent': {
        background: '#fae0e0',
        ...mixins.boxShadow('0 2px 4px 0 rgba(0, 0, 0, 0.07)'),
        padding: '12px 20px 7px',
        '& $alertTitle': {
          marginBottom: '3px',
          fontWeight: 'bold',
          display: 'block',
          fontSize: '16px',
          '@media(min-width:901px)': {
            fontSize: '20px'
          }
        },
        '& $alertButtonContainer': {
          display: 'table',
          width: '100%',
          paddingTop: '3px',
          '& $alertButton': {
            display: 'table-cell',
            verticalAlign: 'middle',
            border: 'solid 1px #d0021b',
            backgroundColor: '#fff',
            height: '35px',
            minWidth: '48px',
            textTransform: 'uppercase',
            margin: '0 10px 7px 0',
            cursor: 'pointer',
            '&:hover': {
              background: '#d0021b',
              color: '#fff',
              ...mixins.transitionAll()
            }
          },
          '@media(min-width:901px)': {
            paddingTop: '13px'
          }
        },
        '@media(min-width:901px)': {
          padding: '20px 30px 10px'
        }
      },
      '@media(min-width:901px)': {
        padding: '30px 20px 0 10px',
        maxWidth: '1190px',
        margin: '0 auto'
      }
    }
  },
  roomPreferenceEnter: {
    transition: 'max-height 0ms ease-out',
    maxHeight: '0'
  },
  roomPreferenceEnterActive: {
    maxHeight: '300px',
    transition: 'max-height 700ms ease-out',
    overflow: 'hidden'
  },
  roomPreferenceLeave: {
    maxHeight: '300px',
    transition: 'max-height 700ms ease-out',
    overflow: 'hidden'
  },
  roomPreferenceLeaveActive: {
    transition: 'max-height 700ms ease-out',
    maxHeight: '0'
  },
  promotionalCodeEnter: {
    transition: 'max-height 0ms ease-out',
    maxHeight: '0'
  },
  promotionalCodeEnterActive: {
    maxHeight: '150px',
    transition: 'max-height 300ms ease-out',
    overflow: 'hidden'
  },
  promotionalCodeLeave: {
    maxHeight: '150px',
    transition: 'max-height 300ms ease-out',
    overflow: 'hidden'
  },
  promotionalCodeLeaveActive: {
    transition: 'max-height 300ms ease-out',
    maxHeight: '0'
  },
  commentaryShow: {},
  relativeFoldCommentaryAnimation: {
    overflow: 'hidden',
    transition: 'height .5s',
    '&$commentaryShow': {
      transition: 'height .5s'
    }
  },

  roomPreferences: {
    cursor: 'pointer',
    font: (data) => '500 16px ' + data.fontFamily1,
    backgroundColor: '#fff',
    color: '#000',
    textAlign: 'left',
    padding: '11px 0 0',
    width: '100%',
    borderBottom: 'none',
    boxSizing: 'border-box',
    '& $roomPreferencesForm': {
      backgroundColor: '#ebebeb',
      '@media (min-width: 801px)': {
        padding: '0 30px'
      }
    },
    '& $roomDetail': {
      pointer: 'cursor',
      borderBottom: '1px solid #999',
      background: '#ebebeb',
      '&:last-child': {
        borderBottom: 'none'
      },
      '& $roomHeader': {
        width: '100%',
        textAlign: 'left',
        padding: '10px 19px 10px 10px',
        fontSize: '13px',
        fontWeight: 'normal',
        position: 'relative',
        boxSizing: 'border-box',
        '& $roomTitle': {
          position: 'relative',
          '& > span': {
            display: 'block',
            paddingLeft: '32px',
            fontWeight: '500',
            position: 'relative',
            fontSize: '16px',
            '&:lang(ar)': {
              paddingRight: '32px',
              paddingLeft: 0
            }
          },
          '& $bedIcon': {
            color: (data) => data.mainColor,
            fontSize: '24px',
            left: '0',
            top: '50%',
            position: 'absolute',
            paddingLeft: '0',
            marginTop: '-17px',
            '@media (min-width: 801px)': {
              fontSize: '32px',
              marginTop: '-22px'
            },
            '&:lang(ar)': {
              left: 'auto',
              right: 0,
              paddingRight: 0
            }
          },
          '& span': {
            '@media (min-width: 801px)': {
              fontSize: '24px',
              paddingLeft: '43px',
              fontWeight: '300'
            },
            '&:lang(ar)': {
              '@media (min-width: 801px), print': {
                paddingLeft: 0,
                paddingRight: '43px'
              }
            }
          },
          '&:after': {
            fontSize: '32px'
          }
        },
        '& $roomSubTitle': {
          margin: '4px 0',
          paddingRight: '15px',
          '& span': {
            '@media (min-width: 801px)': {
              fontWeight: 'bold',
              fontSize: '18px'
            }
          },
          '&:lang(ar)': {
            paddingLeft: '15px',
            paddingRight: 0
          }
        },
        '& $roomToggle': {
          position: 'absolute',
          top: 'calc(50% - 7px)',
          right: '10px',
          height: '15px',
          width: '16px',
          '&$up': {
            '& $searchOptionsButtonIconOpen': {
              font: (data) => '13px/1px ' + data.fontFamily1,
              color: (data) => data.mainColor,
              right: '0px',
              top: '50%',
              position: 'absolute',
              display: 'block',
              transition: 'all .2s ease',
              rotate: '180deg',
              '&:lang(ar)': {
                right: 'auto',
                left: '30px'
              }
            }
          },
          '&$down': {
            '& $searchOptionsButtonIconOpen': {
              font: (data) => '13px/1px ' + data.fontFamily1,
              color: (data) => data.mainColor,
              content: "'e052'",
              right: '0px',
              top: '50%',
              position: 'absolute',
              display: 'block',
              transition: 'all .2s ease',
              '&:lang(ar)': {
                left: '30px',
                right: 'auto'
              }
            }
          },
          '&:lang(ar)': {
            left: '10px',
            right: 'auto'
          }
        },
        '@media (min-width: 801px)': {
          padding: '20px 25px 20px 0'
        },
        '&:lang(ar)': {
          textAlign: 'right',
          paddingLeft: '19px',
          paddingRight: '10px',
          '@media (min-width: 801px), print': {
            paddingLeft: '25px',
            paddingRight: '0'
          }
        }
      },
      '& $preferences': {
        padding: '0 10px 10px 10px',
        '& $preference': {
          pointer: 'cursor',
          ...mixins.boxShadow('0 0 2px -1px rgba(0,0,0,0.5)'),
          ...mixins.boxSizing(),
          marginBottom: '10px',
          border: '1px solid #ddd',
          width: '100%',
          '&:nth-of-type(odd)': {
            '@media (min-width: 801px)': {
              marginRight: '25px'
            },
            '&:lang(ar)': {
              '@media (min-width: 801px), print': {
                marginLeft: '25px',
                marginRight: 0
              }
            }
          },
          '@media (min-width: 801px)': {
            width: 'calc(50% - 15px)',
            display: 'inline-block',
            verticalAlign: 'top'
          }
        },
        '& > :nth-last-child(2)': {
          marginBottom: '0'
        },
        '@media (min-width: 801px)': {
          padding: ' 0 0 20px'
        }
      },
      '& $message': {
        display: 'block',
        marginTop: '16px',
        color: '#000',
        fontSize: '12px',
        lineHeight: '1.38',
        fontWeight: '300',
        '@media (min-width: 801px)': {
          fontSize: '13px'
        }
      },
      '@media (min-width: 801px)': {
        padding: '0 30px'
      }
    },
    '@media (min-width: 801px)': {
      padding: '0'
    },
    '&:lang(ar)': {
      textAlign: 'right'
    }
  },
  disabledButton: {
    background: '#b2b2b2',
    borderColor: '#b2b2b2',
    pointerEvents: 'none',
    '&:hover': {
      background: '#b2b2b2',
      borderColor: '#b2b2b2',
      color: '#fff'
    }
  },
  selectBox: {
    position: 'relative',
    display: 'inline-block',
    verticalAlign: 'top',
    marginRight: '7px',
    height: '40px',
    width: '100%',
    ...mixins.boxShadow('0 0 2px 0 rgba(0, 0, 0, 0.5)'),
    '& $row': {
      padding: '0'
    },
    '& $test': {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      padding: '0 6px 0 23px',
      '& > span': {
        fontSize: '13px'
      },
      '&:lang(ar)': {
        paddingLeft: '6px',
        paddingRight: '23px'
      }
    },
    '& $isSelected': {
      backgroundColor: '#2684ff',
      color: 'white'
    },
    '& $isFocused': {
      backgroundColor: '#deebff',
      color: 'black'
    },
    '& $countries': {
      '@media (min-width: 901px)': {
        height: '50px'
      }
    },
    '@media (min-width: 901px)': {
      height: '50px'
    },
    '&:lang(ar)': {
      marginRight: '0',
      marginLeft: '7px',
      '@media (min-width:910px)': {
        marginRight: '7px',
        marginLeft: '0'
      }
    }
  },
  selectNationality: {
    marginBottom: '10px'
  },
  nationalityContainer: {
    boxShadow: '0 0 2px 0 rgba(0,0,0,50%);',
    flex: '1',
    zIndex: '11',
    position: 'relative',
    '& svg': {
      fill: (data) => data.mainColor
    }
  },
  countryContainer: {
    boxShadow: '0 0 2px 0 rgba(0,0,0,50%);',
    flex: '1',
    zIndex: '2',
    position: 'relative',
    '& svg': {
      fill: (data) => data.mainColor
    }
  },
  documentSelect: {
    '& > div': {
      '& > div': {
        '& > div': {
          marginTop: '0'
        }
      }
    }
  },
  selectDocType: {
    width: '90px',
    float: 'left',
    '& svg': {
      fill: (data) => data.mainColor
    }
  },
  citySelector: {},
  cityBox: {
    float: 'right',
    width: 'calc(50% - 15px)',
    marginRight: '0px'
  },
  countryLabel: {
    zIndex: '3 !important',
    top: '4px !important'
  },
  nationalityLabel: {
    zIndex: '12 !important',
    top: '4px !important'
  },
  citiesLabel: {},
  iconInfo: {
    fontSize: '18px'
  },
  hoursInfo: {
    height: '10%',
    width: '10%'
  },
  hoursSelector: {
    '& > div:first-of-type': {
      '& > div': {
        top: '8px',
        bottom: '10px',
        '& > div': {
          marginLeft: '2px',
          '@media (min-width: 901px)': {
            marginLeft: '0px'
          }
        }
      }
    }
  },
  hourslabel: {
    font: "300 11px 'Roboto', sans-serif",
    color: '#767676',
    cursor: 'default',
    '@media (min-width: 901px)': {
      fontSize: '13px'
    }
  },
  refuseInfoBtn: {
    font: '300 13px Roboto, sans-serif',
    color: (data) => data.mainColor,
    '&:hover': {
      cursor: 'pointer'
    }
  },
  travelClubTextContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    font: '14px Roboto, sans-serif',
    color: '#767676',
    textAlign: 'center',
  },
  travelClubText: {
    textTransform: 'uppercase',
    fontWeight: 'bold',
    color: '#000',
    fontSize: '14px'
  },
  containerBtnsLoyalty: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    clear: 'both',
    marginBottom: '20px',
    '@media (min-width: 801px)': {
      alignItems: 'flex-end',
      marginBottom: 'unset',
      '& button': {
        width: 'calc(25% - 15px)'
      }
    }
  },
  loyaltyForm: {},
  loginCustomerForm: {},
  loginLoyaltyBtn: {
    fontStyle: 'normal',
    background: '#eaf6ff',
    borderColor: '#eaf6ff',
    font: '600 13px "Roboto", sans-serif',
    color: '#36404E',
    '&:hover': {
      background: '#b3d4ed',
      color: '#36404E'
    }
  },
  forgotPassword: {
    font: '300 13px Roboto, sans-serif',
    marginTop: '10px',
    '& span': {
      textDecoration: 'underline'
    }
  },
  membersCheckBox: {},
  memberPass: {},
  membersOnlyContainer: {
    clear: 'both',
    '& > span': {
      display: 'block',
      marginBottom: '20px',
      paddingTop: '5px'
    },
    '& > label$checkBox$membersCheckBox': {
      boxSizing: 'border-box',
      marginBottom: '20px',
      minWidth: '125px',
      width: 'calc(50% - 15px)'
    },
    '& $loginCustomerForm': {
      '& $customerForm': {
        '&$loyaltyForm': {
          '& $containerBtnsLoyalty': {
            padding: 'unset',
            border: 'unset'
          }
        }
      }
    }
  },
  emailWithInfo: {
    display: 'flex'
  },
  containerInfoTrip: {
    display: 'flex',
    flexDirection: 'column',
    clear: 'both',
    '@media (min-width: 901px)': {
      flexDirection: 'row'
    }
  },
  containerTaxesInForm: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px'
  },
  separator: {
    margin: '0 30px',
    content: "''",
    borderBottom: '1px solid #d8d8d8'
  },
  withTreatment: {},
  inputName: {
    zIndex: '15'
  },
  nameContainer: {},
  treatmentSelect: {
    width: '114px',
    boxShadow: 'none'
  },
  hotelFiscalInfo:{},
  labelHours:{},
}
